import { Artikel } from './../classes/artikel';
import { Component, OnInit, ViewChild, HostListener, AfterViewInit } from '@angular/core';
import { NavParams, ModalController, Platform, IonInput } from '@ionic/angular';
import { getConfig } from '../classes/getConfig/getConfig';

@Component({
  selector: 'app-shop-details',
  templateUrl: './shop-details.page.html',
  styleUrls: ['./shop-details.page.scss'],
})
export class ShopDetailsPage implements AfterViewInit {
  @ViewChild('inputHinweis', { read: IonInput }) inputHinweis: IonInput;

  public item: Artikel = null;
  public eh = 0;
  public hinweis = '';
  public small = getConfig().zeigeDetailsInDetailfenster;
  public config = getConfig();
  public isInfo = false;

  constructor(public navParams: NavParams, public modalCtrl: ModalController, public platform: Platform) {
    this.item = navParams.data.item;
    this.isInfo = navParams.data.isInfo;
    this.eh = this.item.pos.eh;
    this.hinweis = this.item.pos.hinweis;
  }

  topfAusblenden(): boolean {
    return this.config.topfAusblenden;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.inputHinweis.setFocus();
    }, 250);
  }

  bestellen() {
    this.item.pos.eh = Math.min(this.eh, this.item.maxEh);
    this.item.pos.hinweis = this.hinweis;

    this.modalCtrl.dismiss(this.item);
  }

  schliessen() {
    this.modalCtrl.dismiss(null);
  }

  ehChanged() {
    if (this.eh > this.item.maxEh) { this.eh = this.item.maxEh; }
  }

  toHinweis(event) {
    if (event.keyCode === 13) {
      this.inputHinweis.setFocus();
    }
  }

  ggfBestellen(event) {
    if (event.keyCode === 13) {
      this.bestellen();
    }
  }

  toggleSmall() {
    this.small = !this.small;
  }
}
